import VoerroTagsInput from './VoerroTagsInput.vue'

window.VoerroTagsInput = VoerroTagsInput;

export default VoerroTagsInput;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@voerro/vue-tagsinput/src/main.js
// module id = 300
// module chunks = 0